import { getMobileOS } from './helpers'
import browserDetect from 'browser-detect'

const browser = browserDetect()
export const isAndroid = getMobileOS?.() === 'Android'
export const isIOS = getMobileOS?.() === 'iOS'
export const isMobileDevice = isAndroid || isIOS
export const isSafari = browser.name === 'safari'
export const isChrome = browser.name === 'chrome'
